<!-- 拍机堂瑕疵映射 -->
<template>
    <div>
        <h2 style="color: #fff">瑕疵映射</h2>
        <div class="form-group">
            <!-- 筛选菜单栏 -->
            <el-form :inline="true" :model="formFlawData">
                <!-- 平台 flawOneLevelList-->
                <el-form-item label="">
                    <el-select v-model="formFlawData.sources" clearable placeholder="平台" @change="sourcesChangeSelect">
                        <el-option v-for="item in platformList" :key="item.id" :label="item.paramValue" :value="item.paramValue" />
                    </el-select>
                </el-form-item>
                <!-- 一级瑕疵 -->
                <el-form-item label="">
                    <el-select v-model="formFlawData.descLevel1" clearable filterable remote placeholder="一级瑕疵" @change="flawChangeSelect">
                        <el-option v-for="item in flawOneLevelList" :key="item" :label="item" :value="item" />
                    </el-select>
                </el-form-item>
                <!-- 二级瑕疵 -->
                <el-form-item label="">
                    <el-select v-model="formFlawData.descLevel2" clearable filterable remote placeholder="二级瑕疵">
                        <el-option v-for="item in flawTwoLevelList" :key="item" :label="item" :value="item" />
                    </el-select>
                </el-form-item>
                <!-- 系统瑕疵 -->
                <el-form-item label="">
                    <el-input v-model="formFlawData.standardsKeyWord" placeholder="系统瑕疵" clearable />
                </el-form-item>
                <!-- 是否映射 -->
                <el-form-item label="">
                    <el-select v-model="formFlawData.status" clearable placeholder="是否映射">
                        <el-option v-for="item in statusList" :key="item.key" :label="item.key" :value="item.value" />
                    </el-select>
                </el-form-item>
                <!-- 操作 -->
                <el-form-item>
                    <el-button type="primary" @click="getFlawDataList()">查询</el-button>
                </el-form-item>
            </el-form>
            <!-- 数据展示 -->
            <el-table :data="flawDataList">
                <!-- 外部平台 -->
                <el-table-column label="平台" min-width="200px">
                    <template #default="scope">
                        {{ scope.row.sources }}
                    </template>
                </el-table-column>
                <!-- 外部型号 -->
                <el-table-column label="其他平台一级瑕疵" min-width="200px">
                    <template #default="scope">
                        {{ scope.row.descLevel1 }}
                    </template>
                </el-table-column>
                <!-- 系统型号 -->
                <el-table-column label="其他平台二级瑕疵" min-width="200px">
                    <template #default="scope">
                        {{ scope.row.descLevel2 }}
                    </template>
                </el-table-column>
                <el-table-column label="系统平台一级瑕疵" min-width="200px">
                    <template #default="scope">
                        {{ scope.row.sdandardsLevel1 }}
                    </template>
                </el-table-column>
                <el-table-column label="系统平台二级瑕疵" min-width="200px">
                    <template #default="scope">
                        {{ scope.row.sdandardsLevel2 }}
                    </template>
                </el-table-column>
                <el-table-column label="系统平台三级瑕疵" min-width="200px">
                    <template #default="scope">
                        {{ scope.row.sdandardsLevel3 }}
                    </template>
                </el-table-column>
                <!-- 操作列 -->
                <el-table-column label="操作" header-align="center" align="center" min-width="200px">
                    <template v-slot="scope">
                        <el-button type="success" @click="showAddFlawDialog(scope.row)" v-if="!scope.row.sdandardsLevel3">添加映射</el-button>
                        <el-button type="success" @click="showEditFlawDialog(scope.row)" v-if="scope.row.sdandardsLevel3"> 编辑</el-button>
                        <el-button type="danger" @click="handleFlawMappingDelete(scope.row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 页码栏 -->
            <el-pagination
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="itemsPerFlawPage"
                layout="total, sizes, prev, pager, next, jumper"
                :total="allPagesFlaw">
            </el-pagination>
        </div>
        <!-- 弹窗修改 -->
        <el-dialog draggable v-model="isFlawDialogVisible" :title="currentFlawMapping.editId == undefined ? '新增瑕疵映射' : '修改瑕疵映射'">
            <el-form :model="currentFlawMapping" :rules="rules" ref="formRef" label-width="120px">
                <el-row>
                    <el-col :span="12">
                        <div style="margin: 0 0 10px 20px">{{ otherPlatformNameFlaw }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="一级瑕疵" prop="sdandardsLevel1">
                            <el-select v-model="currentFlawMapping.sdandardsLevel1" clearable remote placeholder="一级瑕疵" @change="selectOneChange">
                                <el-option v-for="item in sysStandardFlawListOne" :key="item" :label="item" :value="item" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="二级瑕疵" prop="sdandardsLevel2">
                            <el-select v-model="currentFlawMapping.sdandardsLevel2" clearable filterable remote placeholder="二级瑕疵" @change="selectTwoChange">
                                <el-option v-for="item in sysStandardFlawListTwo" :key="item" :label="item" :value="item" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="三级瑕疵" prop="sdandardsLevel3">
                            <el-select v-model="currentFlawMapping.sdandardsLevel3" clearable filterable remote placeholder="三级瑕疵" @change="selectThreeChange">
                                <el-option v-for="item in sysStandardFlawListThree" :key="item.id" :label="item.sdandardsLevel3List" :value="item.id" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <template v-slot:footer>
                <div class="dialog-footer">
                    <el-button @click="isFlawDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="saveFlawMapping">保存</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import FixedButtons from "@/components/FixedButtons.vue";
    import axios from "axios";

    export default {
        name: "damagecheckView",
        components: { FixedButtons },
        data() {
            return {
                props: { multiple: true, label: "paramValue", value: "看后端传来的" },

                //查询各平台
                platformURL: "/api/systemConfig/queryBySystemConfigSearchDTO",

                // 查询各平台的品牌
                platformBrand: "/api/ProductBrandMapping/init",

                // 查询系统品牌
                sysBrand: "/api/ProductBrand/init",

                // 新增时候系统品牌查询
                addSysBrand: "/api/ProductBrand/queryDataByParam",

                // 分页查询其他平台品牌映射到系统品牌数据
                productBrandMapping: "/api/ProductBrandMapping/queryDataByParam",

                // 添加品牌映射关系
                addBrandMapping: "/api/ProductBrandMapping/insertBrandMapping",

                // 编辑品牌映射关系
                editBrandMapping: "/api/ProductBrandMapping/update",

                // 删除品牌映射关系
                deleteBrandMapping: "/api/ProductBrandMapping/deleteBrandMapping",

                //分页查询其他平台机型映射到系统机型数据
                correspondence: "/api/ProductModelMapping/queryModelMappingDataByParam",

                // 添加型号映射关系
                addMapping: "/api/ProductModelMapping/insertModelMapping",

                // 编辑型号映射关系
                editMapping: "/api/ProductModelMapping/update",

                // 删除型号映射关系
                deleteMapping: "/api/ProductModelMapping/deleteModelMapping",

                // 查询平台和机型映射初始化下拉框
                platformModelMapping: "/api/ProductModelMapping/init",

                // 查询系统标准的品牌和机型初始化下拉框
                syspStandardModel: "/api/ProductModel/init",

                // 系统标准型号
                sysModel: "/api/ProductModel/queryDataByParam",

                // 查询瑕疵数据
                flawData: "/api/PlatformDesc/queryDataByParam",

                // 查询瑕疵数据
                flawData: "/api/PlatformDesc/queryDataByParam",

                // 查询下拉框检索数据
                flawSearch: "/api/PlatformDesc/init",

                // 查询下拉框检索数据
                sysStandardFlaw: "/api/PjtDamageStandards/init",

                // 新增瑕疵映射
                addFlawMapping: "/api/PlatformDescReflect/insert",

                // 修改瑕疵映射
                editFlawMapping: "/api/PlatformDescReflect/update",

                // 删除瑕疵映射
                deleteFlawMapping: "/api/PlatformDescReflect/delete",

                // 当前页码
                currentPage: 1,
                // 默认每页显示条目数
                itemsPerPage: 10,
                itemsPerBrandPage: 10,
                itemsPerModelPage: 10,
                itemsPerFlawPage: 10,
                // 总页数
                allPagesBrand: 1,
                allPagesmodel: 1,
                allPagesFlaw: 1,

                BrandReflectShow: true,
                modelReflectShow: false,
                damageReflectShow: false,

                activeName: "first",

                formBrandData: {
                    otherBrandName: "", // 其他平台型号
                    productBrandName: "", // 系统型号
                    sources: "", // 平台
                    status: "", // 是否映射
                },
                platformBrandList: [], //平台品牌
                sysBrandList: [], // 系统品牌
                addSysBrandList: [], // 添加时候的系统品牌
                isBrandDialogVisible: false, //新增编辑弹框
                // brandId: '', //新增id
                // productBrandId: '', //新增品牌id
                brandMappingmName: "",
                currentBrandMapping: {
                    editId: undefined,
                    id: "",
                    productBrandId: "",
                    brandName: "",
                },
                BrandMappingList: [], //其他平台映射系统平台列表

                formData: {
                    brandId: "", //系统品牌id
                    otherModelName: "", // 其他平台型号
                    productModelName: "", // 系统型号
                    sources: "", // 平台
                    status: "", // 是否映射
                },
                statusList: [
                    { key: "已映射", value: "0" },
                    { key: "未映射", value: "1" },
                ],
                platformList: [], // 平台信息
                correspondenceList: [], // 对应信息
                sysPlatformBrandList: [], //系统平台品牌
                sysPlatformModelList: [], //系统平台型号
                otherPlatformModelList: [], // 其他平台型号
                sources: "", //平台
                brandId: "",
                isBrandId: "", //系统平台品牌是否映射过
                isBrandName: "",
                isDialogVisible: false, //新增编辑弹框
                sysModelList: [], // 系统标准型号列表
                otherPlatformName: "",
                currentMapping: {
                    editId: undefined,
                    id: "",
                    brandId: "",
                    productModelId: "",
                    modelName: "",
                    editProductModelId: "",
                },

                formFlawData: {
                    descLevel1: "", //一级瑕疵
                    descLevel2: "", // 二级瑕疵
                    standardsKeyWord: "", // 系统瑕疵
                    sources: "", // 平台
                    status: "", // 是否映射
                },
                flawDataList: [], // 瑕疵映射列表
                flawOneLevelList: [], //一级瑕疵
                flawTwoLevelList: [], //二级瑕疵
                sysStandardFlawListOne: [], //系统一级瑕疵数据
                sysStandardFlawListTwo: [], //系统二级瑕疵数据
                sysStandardFlawListThree: [], //系统三级瑕疵数据
                isFlawDialogVisible: false, //瑕疵弹框
                currentFlawMapping: {
                    editId: undefined,
                    id: "",
                    sdandardsLevel1: "", //一级名字
                    sdandardsLevel2: "", //二级名字
                    sdandardsLevel3: "", //三级名字
                    otherPlatformDescId: "",
                    pjtDescId: "",
                },
                otherPlatformNameFlaw: "",

                rules: {
                    modelName: [{ required: true, message: "系统标准型号不能为空", trigger: "blur" }],
                },
            };
        },
        created() {
            this.nickName = localStorage.getItem("nickname") || "";
            this.phone = localStorage.getItem("tel") || "";
            // this.getPlatformList();
            // this.getFlawDataList();
            // this.getFlawSearchList();
        },
        methods: {
            nowtabInit() {
                this.nickName = localStorage.getItem("nickname") || "";
                this.phone = localStorage.getItem("tel") || "";
                this.getPlatformList();
                this.getFlawDataList();
                this.getFlawSearchList();
            },
            // 删除瑕疵映射
            handleFlawMappingDelete(row) {
                try {
                    this.$confirm("确认删除当前瑕疵映射吗?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            axios
                                .delete(this.deleteFlawMapping + `?idList=${row.platformDescReflectId}`, {
                                    headers: {
                                        satoken: localStorage.sa,
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((res) => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            message: res.data.message,
                                            type: "success",
                                        });
                                        this.getFlawDataList();
                                    } else {
                                        this.$message.error(res.data.data);
                                    }
                                })
                                .catch((error) => {
                                    // 处理错误
                                    console.error("删除失败", error);
                                });
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消删除",
                            });
                        });
                } catch (error) {
                    console.error("Failed to delete user:", error);
                }
            },
            // 新增保存and编辑保存
            saveFlawMapping() {
                this.$refs.formRef.validate((valid) => {
                    if (valid) {
                        if (this.currentFlawMapping.editId === undefined) {
                            const body = {
                                otherPlatformDescId: this.currentFlawMapping.otherPlatformDescId,
                                pjtDescId: this.currentFlawMapping.pjtDescId,
                            };
                            axios
                                .post(this.addFlawMapping, body, {
                                    headers: {
                                        satoken: localStorage.sa,
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((res) => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            message: res.data.message,
                                            type: "success",
                                        });
                                        this.isFlawDialogVisible = false;
                                        this.getFlawDataList();
                                    } else {
                                        this.$message({
                                            message: res.data.message,
                                            type: "error",
                                        });
                                    }
                                })
                                .catch((error) => {
                                    // 处理错误
                                    console.error("新增失败", error);
                                });
                        } else {
                            const body = {
                                id: this.currentFlawMapping.id,
                                otherPlatformDescId: this.currentFlawMapping.otherPlatformDescId,
                                pjtDescId: this.currentFlawMapping.pjtDescId,
                            };
                            axios
                                .put(this.editFlawMapping, body, {
                                    headers: {
                                        satoken: localStorage.sa,
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((res) => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            message: res.data.message,
                                            type: "success",
                                        });
                                        this.isFlawDialogVisible = false;
                                        this.getFlawDataList();
                                        this.currentFlawMapping.pjtDescId = "";
                                    } else {
                                        this.$message({
                                            message: res.data.data,
                                            type: "error",
                                        });
                                    }
                                })
                                .catch((error) => {
                                    // 处理错误
                                    console.error("新增失败", error);
                                });
                        }
                    }
                });
            },
            // 改变条数
            handleSizeChange2(val) {
                this.itemsPerFlawPage = val;
                this.getFlawDataList();
            },
            //改变页数
            handleCurrentChange2(val) {
                this.currentPage = val;
                this.getFlawDataList();
            },
            // 根据平台去查
            sourcesChangeSelect(val) {
                this.formFlawData.sources = val;
                this.getFlawSearchList();
            },
            // 根据一级瑕疵去查
            flawChangeSelect(val) {
                this.formFlawData.descLevel1 = val;
                this.getFlawSearchList();
            },
            // 查询下拉检索数据
            getFlawSearchList() {
                axios
                    .get(this.flawSearch, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerFlawPage,
                            sources: this.formFlawData.sources,
                            descLevel1: this.formFlawData.descLevel1,
                            descLevel2: this.formFlawData.descLevel2,
                        },
                    })
                    .then((res) => {
                        if (this.formFlawData.descLevel1) {
                            this.flawTwoLevelList = res.data.data.descLevel2List;
                        } else {
                            this.flawOneLevelList = res.data.data.descLevel1List;
                            this.flawTwoLevelList = res.data.data.descLevel2List;
                        }
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            // 查询瑕疵列表
            getFlawDataList() {
                axios
                    .get(this.flawData, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            ...this.formFlawData,
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerFlawPage,
                        },
                    })
                    .then((res) => {
                        this.flawDataList = res.data.data.result;
                        this.allPagesFlaw = res.data.data.total;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // 查询平台
            getPlatformList() {
                axios
                    .get(this.platformURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerPage,
                            // paramKey: "USER_VISIBLE_PLATFORM_NAME",
                        },
                    })
                    .then((res) => {
                        this.platformList = res.data.data.result;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // 查询pjt一二三级瑕疵数据
            getSysStandardFlawList() {
                axios
                    .get(this.sysStandardFlaw, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerFlawPage,
                            sdandardsLevel1: this.currentFlawMapping.sdandardsLevel1,
                            sdandardsLevel2: this.currentFlawMapping.sdandardsLevel2,
                        },
                    })
                    .then((res) => {
                        if (!this.currentFlawMapping.sdandardsLevel1 && !this.currentFlawMapping.sdandardsLevel2) {
                            this.sysStandardFlawListOne = res.data.data.sdandardsLevel1List;
                            this.sysStandardFlawListTwo = res.data.data.sdandardsLevel2List;
                            this.sysStandardFlawListThree = res.data.data.sdandardsLevel3VOList;
                        } else if (this.currentFlawMapping.sdandardsLevel1 && !this.currentFlawMapping.sdandardsLevel2) {
                            this.sysStandardFlawListTwo = res.data.data.sdandardsLevel2List;
                        } else {
                            this.sysStandardFlawListThree = res.data.data.sdandardsLevel3VOList;
                        }
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            selectOneChange(val) {
                this.currentFlawMapping.sdandardsLevel1 = val;
                this.getSysStandardFlawList();
            },

            selectTwoChange(val) {
                this.currentFlawMapping.sdandardsLevel2 = val;
                this.getSysStandardFlawList();
            },

            selectThreeChange(val) {
                this.getSysStandardFlawList(val);
                this.currentFlawMapping.pjtDescId = val;
            },

            // 新增瑕疵映射关系
            showAddFlawDialog(row) {
                this.isFlawDialogVisible = true;
                this.currentFlawMapping.otherPlatformDescId = row.id;
                this.getSysStandardFlawList();
            },

            // 编辑瑕疵映射
            showEditFlawDialog(row) {
                this.isFlawDialogVisible = true;
                this.currentFlawMapping.editId = row.id;
                this.currentFlawMapping.id = row.platformDescReflectId;
                this.currentFlawMapping.otherPlatformDescId = row.otherPlatformDescId;
                this.currentFlawMapping.pjtDescId = row.pjtDescId;
                this.currentFlawMapping.sdandardsLevel1 = row.sdandardsLevel1;
                this.currentFlawMapping.sdandardsLevel2 = row.sdandardsLevel2;
                this.currentFlawMapping.sdandardsLevel3 = row.sdandardsLevel3;
                this.getSysStandardFlawList();
            },
        },
        watch: {},
        computed: {},
        mounted() {},
    };
</script>

<style lang="scss" scoped></style>
